

































import { Component, Vue, Prop } from "vue-property-decorator";
import document from "../../assets/images/document.png";
import Bus from "../../utils/bus";
type Form = { icon: ""; title: "新闻中心"; type: ""; list: []; total: 0 };

@Component({
  components: {}
})
export default class WebsiteBody extends Vue {
  @Prop({
    type: Object,
    default: { icon: document, title: "新闻中心", type: "" }
  })
  private info: Form;
  private type: any = "";
  created() {
    this.type = this.$route.path.slice(1);
  }
  goDetail(id) {
    this.$router.push({ name: "详情", params: { id } });
  }
  // currentPage 改变时会触发
  private currentChange(val) {
    Bus.$emit(`${this.type}/currentChange`, val);
  }
  private prevClick() {
    Bus.$emit(`${this.type}/prevClick`);
  }
  private nextClick() {
    Bus.$emit(`${this.type}/nextClick`);
  }
}
